module.exports = __webpack_public_path__ + "static/media/HOD.7d549325.png";